export default {
  tab: 9,
  enter: 13,
  escape: 27,
  space: 32,
  up: 38,
  down: 40
};